import { FC } from "react";
import { CommitmentsPageHeaderMetadataCard } from "@/components/pages/commtiments/common/components/metadata-card/CommitmentsPageHeaderMetadataCard";
import { money } from "@/utils/numeral/money";
import { useAppSelector } from "@/store/hooks";
import { overviewRealCostSelector } from "@/store/commitments/selectors/overview/overviewRealCostSelector";
import { overviewLoadingSelector } from "@/store/commitments/selectors/overview/loading/overviewLoadingSelector";

export const CommitmentsOverviewMetadataRealCostCard: FC = () => {
  const realCost = useAppSelector(overviewRealCostSelector);

  const loading = useAppSelector(overviewLoadingSelector);

  return (
    <CommitmentsPageHeaderMetadataCard
      primary="Real Cost"
      loading={loading}
      value={realCost === null ? "N/A" : money(realCost)}
      tooltip="Total costs paid for all resources eligible for commitments (Savings Plans, Reserved Instances) including RI fees and Savings Plan Recurring Fees."
      descriptionText="Total eligible costs (RI & SP combined)"
      sx={{ flex: 1 }}
    />
  );
};
